import { groupBy, forEach } from 'lodash';

import { DigitalCheckoutInput, PhotoInput } from '__generated__/globalTypes';
import { DigitalCheckoutFormState } from 'sellDirect/components/closingDash/closing/DigitalCheckoutForm';
import {
  DigitalCheckoutFormPhoto,
  DigitalCheckoutPhotoKind,
  photoSections,
} from 'sellDirect/declarations/DigitalCheckoutPhotos';
import { isValidInput } from 'sellDirect/helpers/closingDash/serviceProvidersPageCompleted';

const isPhotoUploadValid = (
  photos?: Array<DigitalCheckoutFormPhoto>,
): { isPhotoUploadComplete: boolean; photoErrors: Record<DigitalCheckoutPhotoKind, boolean> } => {
  const photosByKind = groupBy<DigitalCheckoutFormPhoto>(photos, 'kind');
  const photoErrors = {} as Record<DigitalCheckoutPhotoKind, boolean>;

  forEach(photoSections, ({ kind, numRequired }) => {
    const hasEnoughPhotos = kind in photosByKind && photosByKind[kind].length >= numRequired;
    photoErrors[kind] = !hasEnoughPhotos;
  });

  return {
    photoErrors,
    isPhotoUploadComplete: Object.values(photoErrors).every((hasError) => !hasError),
  };
};

/** TODO: Add documentation */
export const isDigitalCheckoutFormValid = (
  formState: DigitalCheckoutFormState,
  photolessOverride: boolean,
): {
  isValid: boolean;
  isPhotoUploadComplete: boolean;
  photoErrors?: Record<DigitalCheckoutPhotoKind, boolean>;
} => {
  const isValid = [
    formState?.declaration,
    formState?.phoneNumber,
    formState?.lockboxLocation === 'other'
      ? formState?.lockboxLocationOther
      : formState?.lockboxLocation,
  ].every((item) => isValidInput(item));
  if (photolessOverride) {
    return { isValid, isPhotoUploadComplete: true, photoErrors: undefined };
  }
  const { isPhotoUploadComplete, photoErrors } = isPhotoUploadValid(formState?.photos);
  return { isValid, isPhotoUploadComplete, photoErrors };
};

// Todo: fix this
const getLockboxLocation = (formState: DigitalCheckoutFormState): string =>
  formState.lockboxLocation === 'other'
    ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
      formState?.lockboxLocationOther!
    : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
      formState?.lockboxLocation!;

const transformPhotoInput = (formPhoto: DigitalCheckoutFormPhoto): PhotoInput => {
  return {
    url: formPhoto.downloadUrl || '',
    mimeType: formPhoto.file.type || '',
    photoIdentifier: formPhoto.s3Key || '',
    fileName: formPhoto.file.name || '',
    kind: formPhoto.kind,
  };
};

const getDigitalCheckoutPhotos = (
  formPhotos: Array<DigitalCheckoutFormPhoto> | undefined,
): Array<PhotoInput> | undefined => {
  return formPhotos?.map((formPhoto) => transformPhotoInput(formPhoto));
};

// Todo: fix this
/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/** TODO: Add documentation */
export const digitalCheckoutFormToMutationInput = (
  formState: DigitalCheckoutFormState,
): DigitalCheckoutInput => ({
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  declaration: formState?.declaration!,
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  phoneNumber: formState?.phoneNumber!,
  lockboxLocation: getLockboxLocation(formState),
  photos: getDigitalCheckoutPhotos(formState?.photos),
});
/* eslint-enable @typescript-eslint/no-non-null-asserted-optional-chain */
